import type { CollectionItemDetail } from "@/services/collection/item/collectionItemTypes";
import { ItemStatus } from "@/services/collection/item/collectionItemTypes";
import { PriceNumericOrEmpty_Schema } from "@/services/prices/priceSchema";
import { WholeNumber_Schema } from "@/utilities/schema";
import { z } from "zod";
import { CategoryId_Schema } from "@/services/collection/categories/categoriesSchema";
import { ApiResponse_Image_Schema } from "@/services/images";
import { FilledInParameter_Schema } from "@/services/parameters/parametersSchema";
import { CollectibleElastic_Schema } from "@/services/collectibles/elastic/collectiblesElasticSchema";
import { AiIdentificationId_Schema } from "@/services/aiIdentification/aiIdentificationSchema";

import { CollectionItemId_Schema } from "@/services/collection/item/collectionItemIdSchema";
import { MarketplaceItemBasics_Schema } from "@/services/marketplace/item/marketplaceItemBasicsSchema";
export { CollectionItemId_Schema };

export const CollectionItemStatus_Schema = z.enum(ItemStatus);

// Just a swiftly created schema - better/stricter definitions would be nice.
export const CollectionItem_Schema = z
  .object({
    id: CollectionItemId_Schema,

    acquirePrice: PriceNumericOrEmpty_Schema,
    currentPrice: PriceNumericOrEmpty_Schema,
    lastPrice: PriceNumericOrEmpty_Schema,

    categoryId: CategoryId_Schema,
    dateAcquired: z.string(), // YYYY-MM-DD
    images: ApiResponse_Image_Schema.array(),
    name: z.string(),

    metaParameters: FilledInParameter_Schema.array(),

    note: z.string().nullable(),
    publicNote: z.string(),

    pieces: WholeNumber_Schema,

    userCollectionList: z.string().array(),
    whereStored: z.string(),
    acquisitionSource: z.string(),
    statusList: CollectionItemStatus_Schema.array(),

    likesCount: WholeNumber_Schema,
    likedByCurrentUser: z.boolean(),

    marketPlaceItem: MarketplaceItemBasics_Schema.nullable(),

    // @todo Would be nice to get rid off this property - needs BE rework
    detail: z.object().optional(),

    collectibleElastic: CollectibleElastic_Schema.nullable(),
    aiIdentificationId: AiIdentificationId_Schema.nullable(),
  })
  .meta({ openapi: "CollectionItemResponse" })
  .transform(({ detail, ...rest }) => ({
    ...rest,

    // These are just to overcome not-existing schemas - no time to do it better.
    detail: detail as CollectionItemDetail | undefined,
  }));
